module.exports = __webpack_public_path__ + "img/IanLaiVote.6705423d.svg";